export default __webpack_public_path__ + "static/media/icon-arrow-up-red.9fa12690.svg";